export function isFeatureEnabled(name) {
  const value = process.env[name];

  return value === "true";
}
